import {addClass, find, setAttribute} from "@elements/dom-utils";

let alpsteinLoaded = false;
let alpsteinDone = false;

export function init() {
    if( alpsteinLoaded || alpsteinDone){
        return;
    }
    alpsteinLoaded = true;
    setTimeout(function () {
        var dp = oa.api.detailpage(ssiid);

        // the div container with class "oax-top-cont" is hidden on page load
        // show the div container as soon as the FlexView API detail page was loaded
        dp.whenLoaded(function () {
            document.getElementsByClassName("oax-top-cont")[0].style.height = "auto";
            alpsteinDone = true;
            let loadingElement = find('#alpsteinLoading');
            addClass('hidden', loadingElement);
            setAttribute('hidden', 'hidden', loadingElement);
        });
    }, 2000);
}
